import { cloneDeep } from 'lodash'
import store from "@/store/index"
import { getCurrentTime, getCurrentWeather } from '@/api/utils.js'
import { dealText } from '@/api/common.js'

export const getCustomVal = (i, payLoadCustomData) => {
  let res = ''
  const customData = payLoadCustomData || store.state.doorCustomData || [] // 当前页面的自定义参数
  const index = customData.findIndex(iter => iter.name === i.name)
  if (index !== -1) {
    res = customData[index].value
    if (Array.isArray(res) && customData[index].type === 'relation-user') {
      res = res.map(item => {
        return {
          realname: item.realname,
          userId: item.userId
        }
      })
    }
  }
  return res
}

// 给配置页面的变量设置默认值
export const setConfigCustomData = async (customData) => {
  customData.forEach(async item => {
    if (item.type2 && item.type2 !== 'custom') {
      item.value = await setCustomDefaultData(item)
    } else if (item.type === 'text' && typeof item.value === 'string' && item.value.search('{') !== -1) {
      const res = dealText({
        text: item.value,
        commonData: store.state.userData,
        customData: cloneDeep(customData),
        functionParms: item.functionParms || []
      })
      item.value = res || item.value
    }
  })
  return customData
}

export const setCustomDefaultData = async (item = {}) => {
  let value = ''
  if (JSON.stringify(store.state.userData) === '{}') {
    await store.dispatch('setAsyncUserData')
  }
  const userData = cloneDeep(store.state.userData)
  if (item.type === 'relation-user') {
    if (item.type2 === 'currentUser') {
      value = [userData]
    }
  } else if (item.type === 'organization') {
    if (item.type2 === 'currentOrg') {
      value = userData.orgList || []
      if (item.orgType) {
        value = value.filter(iten => { return item.orgType == iten.type })
      }
    }
  } else if (item.type === 'date') {
    if (item.type2) {
      value = getCustomCurrentTime(cloneDeep(item))
    }
  } else if (item.type === 'interface') {
    if (item.type2 === 'weather') {
      const weatherInfo = await getCurrentWeather()
      value = weatherInfo.dayweather
    }
  }
  return value
}

// 设置时间的默认值
export const getCustomCurrentTime = (custom) => {
  let customVal = custom.value
  const time = getCurrentTime()
  if (custom.type2 === 'timeDivision') {
    customVal = `${time.hour}:${time.minute}`
  } else if (custom.type2 === 'monthDay') {
    customVal = `${time.month}月${time.date}日`
  } else if (custom.type2.search('yearMonthDay') !== -1) {
    const format = custom.type2.split('_')[1]
    if (format === 'yyyy-mm-dd') {
      customVal = `${time.year}-${time.month}-${time.date}`
    }
  }
  return customVal
}

// 设置传参格式
export const setParamsList = (paramsList, customData) => {
  const resParamsList = []
  paramsList.forEach(iter => {
    const obj = { name: iter.otherParam }
    if (iter.type === 'input') {
      // 自定义的
      obj.value = iter.currentParam
      resParamsList.push(obj)
    } else {
      const index = customData.findIndex(citer => citer.name === iter.currentParam)
      if (index !== -1) {
        obj.value = customData[index].value
        resParamsList.push(obj)
      }
    }
  })
  return resParamsList
}

// 筛选器的变量默认值
export const getFilterValue = (filterValue, customDataList= []) => {
  let res = []
  if (typeof filterValue === 'string') {
    filterValue = [filterValue]
  }
  if (Array.isArray(filterValue)) {
    filterValue.forEach(item => {
      if (item && (item[0] === '$' || (typeof item === 'object' && item.datatype))) {
        let name = item[0] === '$' ? item.split('$')[1] : item.name
        name = name.replace('{', '')
        name = name.replace('}', '')
        const val = getCustomVal({ name }, customDataList) || ''
        if (Array.isArray(val)) {
          item = val.filter(iten => { return iten || item === 0 })
        } else {
          item = typeof val === 'number' ? [val] : val.split(',')
        }
        if (item || item === 0) {
          res.push(...item)
        }
      } else if (item || item === 0) {
        res.push(item)
      }
    })
  }
  return res
}

// 筛选器的绑定值

export const getFilterBindField = (bindField, customDataList= []) => {
  let data
    const name = bindField.split('$')[1]
    if (name === 'currentOrg') {
      // 当前用户的组织
      data = (store.state.userData['部门'] || []).split(',')
    } else if (name === 'currentRole') {
      data = (store.state.userData['角色'] || []).split(',')
    } else if (name) {
      const index = customDataList.findIndex(i => { return i.name === name })
      if (index !== -1) {
        const val = customDataList[index].value
        if (Array.isArray(val)) {
          data = val.filter(item => { return item || item === 0 })
        } else if (typeof val === 'object') {
          data = [val]
        } else {
          data = typeof val === 'number' ? [val] : val.split(',')
        }
      }
    }
  
  return data
}

// 设置请求数据的的参数
export const setCustomData = (customDataList) => {
	const customData = {}
	customDataList.map(item => {
		let val = item.value
		if (item.type === 'relation-user') {
			if (Array.isArray(val)) {
				val = val.map(iter => {
					return {
						realname: iter.realname,
						userId: iter.userId
					}
				})
			}
			
		} else if (item.type === 'organization' || item.type === 'roule') {
			// if (Array.isArray(val)) {
			// 	val = val.map(iter => {
			// 		return iter.organizationId || iter.roleId
			// 	})
			// }
		} else if (item.type === 'text' && typeof val === 'string' && val.search('{') !== -1) {
			const res = dealText({
				text: val,
				commonData: store.state.userData,
				customData: customDataList,
				functionParms: item.functionParms || []
			})
			val = res || val
		}
		customData[item.name] = typeof val === 'string' && val.search(',') !== -1 ? val.split(',') : val
	})
	return customData
}